import Right from "../../../../../newUXAssets/icons/Right";
import Down from "../../../../../newUXAssets/icons/Down";
import { useMemo, useState, useEffect } from "react";
import { useIntl } from "react-intl";

import {
  Container,
  Header,
  Text,
  Seach,
  CustomTable,
  InputSearch,
  Empty,
} from "./styles";

const Table = ({
  dataSource,
  title,
  height = 368,
  tablePagination = {},
  handleGetInfoTable = () => {},
  isDisabledSeach = false,
  haveExpandable = false,
  notEven = false,
  disabledPagination = false,
  expandedRowRender = () => {},
  ...props
}) => {
  const intl = useIntl();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    if (haveExpandable && Array.isArray(dataSource)) {
      setExpandedRowKeys(dataSource.map((row) => row.key));
    }
  }, [dataSource, haveExpandable]);

  const handleSetValueSearch = (value) => {
    setTimeout(() => {
      handleGetInfoTable(0, 10, value);
    }, 1000);
    setSearchValue(value);
  };

  const optionsPagination = useMemo(() => {
    if (disabledPagination) {
      return false;
    }

    return {
      simple: true,
      position: ["bottomCenter"],
      ...tablePagination,
      onChange: (page, pageSize) => {
        handleGetInfoTable(page - 1, pageSize, searchValue);
      },
    };
  }, [disabledPagination, tablePagination, handleGetInfoTable]);

  const otherProps = useMemo(() => {
    if (haveExpandable) {
      return {
        ...props,
        expandable: {
          expandedRowRender,
          expandedRowKeys,
          onExpand: (expanded, record) => {
            if (expanded) {
              setExpandedRowKeys((prevKeys) => [...prevKeys, record.key]);
            } else {
              setExpandedRowKeys((prevKeys) =>
                prevKeys.filter((key) => key !== record.key)
              );
            }
          },
          expandIcon: ({ expanded, onExpand, record }) => {
            const hasChildren =
              Array.isArray(record.relatedProducts) &&
              record.relatedProducts.length > 0;
            const commonProps = {
              style: hasChildren ? {} : { opacity: 0.3 },
              disabled: !hasChildren,
              onClick: hasChildren
                ? (e) => onExpand(record, e)
                : (e) => e.stopPropagation(),
            };
            return expanded ? (
              <Down {...commonProps} />
            ) : (
              <Right {...commonProps} />
            );
          },
        },
      };
    }
    return props;
  }, [props, haveExpandable, expandedRowRender, expandedRowKeys]);

  return (
    <Container $notEven={notEven}>
      {(title || !isDisabledSeach) && (
        <Header>
          <Text>{title}</Text>
          {!isDisabledSeach && (
            <Seach>
              <InputSearch
                name="search-table"
                type="seach"
                placeholder={intl.formatMessage({ id: "search" })}
                onChange={({ target }) => handleSetValueSearch(target.value)}
              />
            </Seach>
          )}
        </Header>
      )}
      <CustomTable
        dataSource={dataSource}
        $isEmpty={dataSource?.length === 0}
        $notEven={notEven}
        locale={{
          emptyText: (
            <Empty>{intl.formatMessage({ id: "no_results_to_display" })}</Empty>
          ),
        }}
        scroll={{
          x: "100%",
          y: height,
        }}
        pagination={optionsPagination}
        {...otherProps}
      />
    </Container>
  );
};

export default Table;
